import moment from 'moment';
import {formatDateShort} from 'lib/helpers/globalize-helper';

const transformData = (type, body) => {
  if (type === 'ekdotiria') {
    return body.port_agencies.sort(({location: locationA}, {location: locationB}) =>
      locationA.localeCompare(locationB));
  }
  return {
    cancel: cancellationData(body.results.data.cancelPolicy),
    open: openData(body.results.data.openPolicy),
    companyName: body.results.data.companyName
  };
};

const cancellationData = ({policies, nonRefundableClasses}) => ({
  policies: (policies || []).map((policy) => ({
    ...policy,
    dates: policy.dates.map(({validFrom, validTo}) => (
      `${formatDateShort(moment(validFrom, 'DD/MM/YYYY'))} - ${formatDateShort(moment(validTo, 'DD/MM/YYYY'))}`
    ))
  })),
  nonRefundableClasses: (nonRefundableClasses || []).map(({description}) => description)
});

const openData = ({policies}) => ({
  policies: (policies || []).map((policy) => ({
    ...policy,
    dates: policy.dates.map(({validFrom, validTo}) => (
      `${formatDateShort(moment(validFrom, 'DD/MM/YYYY'))} - ${formatDateShort(moment(validTo, 'DD/MM/YYYY'))}`
    ))
  }))
});

export {transformData};
